// Set up carousels
import $ from 'jquery';
import 'bootstrap';

$(function () {
  $('.carousel').carousel()
});
